export default {
  title: "",
  excerpt: "",
  lang: "oz",
  slug: "",
  avatar_file: null,
  paper_file: null,
  date: null
}
